import WindowDimensions from "hooks/useDimensions";
import { useLocation } from "react-router-dom";
import st_wallet from "./WalletButton.module.css";

const InitializingButton = () => {
    const location = useLocation();
    const isWeb = WindowDimensions();

    return (
        <button className={
            !isWeb ? st_wallet.mobile_connect_btn: location.pathname === "/" ? 
        st_wallet.home_wallet_button : st_wallet.charity_wallet_button}>
            Loading...
        </button>
    )
}

export default InitializingButton;